import { Button, Grid, Typography, Box } from '@mui/material'
import { styled } from '@mui/system'
import OcrReaderLogo from 'assets/images/logoSl.svg'
import { LINK_SUPPORT } from 'config'

import LoginLayout from './LoginLayout'

const GridContainer = styled(Grid)({
  height: '100vh',
})

const LbSidebar = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: 'rgb(5, 214, 134)',
  color: '#ffffff',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const LbContent = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  color: '#888888',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  paddingRight: '15px',
  paddingLeft: '15px',
}))

const Logo = styled(Box)({
  width: '100%',
  maxWidth: '330px',
  height: '50px',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  backgroundImage: `url("${OcrReaderLogo}")`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
})

const LbInstruction = styled('div')(() => ({
  width: '100%',
  minHeight: '180px',
  overflow: 'hidden',
  fontSize: '16px',
  lineHeight: '1.7em',
  letterSpacing: '0.02em',
  textAlign: 'center',
}))

const BtnSecondary = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 550,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: 'rgb(5, 214, 134)',
  borderColor: 'rgb(5, 214, 134)',
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: 'rgb(5, 214, 134)',
    borderColor: 'rgb(5, 214, 134)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0062cc',
    borderColor: '#005cbf',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
})

const LoginFailure: React.FC = () => {
  const toSupportPage = () => {
    window.location.href = LINK_SUPPORT
  }
  return (
    <LoginLayout>
      <GridContainer container>
        <LbSidebar item sm={5} xl={5}>
          <Logo />
        </LbSidebar>
        <LbContent item sm={7} xl={7}>
          <LbInstruction>
            <Typography variant="body1" sx={{ marginBottom: (theme) => theme.spacing(2) }}>
              OCR Readerへのログインに失敗しました。
              <br />
              サービス担当者へお問い合わせください。
            </Typography>
            <BtnSecondary variant="contained" disableRipple onClick={toSupportPage}>
              お問い合わせ
            </BtnSecondary>
          </LbInstruction>
        </LbContent>
      </GridContainer>
    </LoginLayout>
  )
}

export default LoginFailure
